import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { useAuth } from '../hooks/useAuth';

export function NavigationListener() {
	const navigate = useNavigate();
	const location = useLocation();
	const { user: dbUser } = useAuth();

	// Only query for navigation events if we have a user email
	const latestNavigation = useQuery(
		api.navigation.getLatestNavigation,
		dbUser?.email ? { userEmail: dbUser.email } : 'skip'
	);

	const markProcessed = useMutation(api.navigation.markNavigationProcessed);

	useEffect(() => {
		try {
			// console.log('Navigation state:', {
			// 	hasLatestNavigation: !!latestNavigation,
			// 	navigationData: latestNavigation,
			// 	currentUserEmail: dbUser?.email,
			// 	currentPath: location.pathname,
			// 	triggerAction: latestNavigation?.triggerAction,
			// });

			if (latestNavigation && !latestNavigation.processed) {
				console.log('🎯 [NavigationListener] Processing navigation:', {
					route: latestNavigation.route,
					triggerAction: latestNavigation.triggerAction,
					currentPath: location.pathname,
					timestamp: new Date().toISOString(),
				});

				// Check for voice dialog
				const voiceDialog = document.querySelector(
					'[data-voice-dialog]'
				);
				console.log('🔍 [NavigationListener] Voice dialog check:', {
					found: !!voiceDialog,
					timestamp: new Date().toISOString(),
				});

				if (voiceDialog) {
					console.log(
						'🎯 [NavigationListener] Found voice dialog - minimizing'
					);
					const minimizeEvent = new CustomEvent(
						'minimize-voice-dialog'
					);
					document.dispatchEvent(minimizeEvent);
				}

				// Only navigate if we're not already on the target route
				const shouldNavigate =
					location.pathname !== latestNavigation.route;

				if (shouldNavigate) {
					console.log(
						'🚀 [NavigationListener] Navigating to:',
						latestNavigation.route
					);
					navigate(latestNavigation.route);
				} else {
					console.log(
						'🎯 [NavigationListener] Already on target route, skipping navigation'
					);
				}

				// Handle trigger actions after navigation (or immediately if already on route)
				const handleTriggerAction = () => {
					if (latestNavigation.triggerAction === 'generate-content') {
						console.log(
							'🎯 [NavigationListener] Triggering content generation'
						);
						document.dispatchEvent(
							new Event('trigger-content-generation')
						);
					} else if (
						latestNavigation.triggerAction === 'publish-content'
					) {
						console.log(
							'🎯 [NavigationListener] Triggering content publishing'
						);
						document.dispatchEvent(
							new Event('trigger-content-publishing')
						);
					}
				};

				if (shouldNavigate) {
					// Add a small delay to ensure component is mounted
					setTimeout(handleTriggerAction, 1000);
				} else {
					// Execute immediately if we're already on the right route
					handleTriggerAction();
				}

				// Mark the navigation as processed
				markProcessed({ eventId: latestNavigation._id })
					.then(() => {
						console.log('Navigation event marked as processed');
					})
					.catch((error) => {
						console.error(
							'Failed to mark navigation as processed:',
							error
						);
					});
			}
		} catch (error) {
			console.error('Navigation error:', error);
		}
	}, [
		latestNavigation,
		navigate,
		markProcessed,
		dbUser?.email,
		location.pathname,
	]);

	return null;
}
